// extracted by mini-css-extract-plugin
export default {"modalWrapper":"CheckResult_modalWrapper__IGJHx","modalWrapper2":"CheckResult_modalWrapper2__ub40d","loader":"CheckResult_loader__vE8SI","l3":"CheckResult_l3__nMmCF"};